{
  "en": {
    "button": {
      "actions": {
        "add": "Add",
        "cancel": "Cancel",
        "close": "Close",
        "copyEmail": "Copy email",
        "create": "Create",
        "delete": "Delete",
        "display": "Display",
        "edit": "Edit",
        "hide": "Hide",
        "loading": "Loading",
        "move": "Move",
        "no": "No",
        "reset": "Reset",
        "save": "Save",
        "save_changes": "Save changes",
        "save_message": "Save message",
        "saving": "Saving",
        "share": "Share",
        "startTour": "Start tour",
        "uploadingDocuments": "Uploading documents",
        "yes": "Yes"
      }
    }
  }
}